module.exports = __webpack_public_path__ + "static/assist-2fd804f1187d722dd15cfca3d794b02b.webp";